import React, { useEffect } from 'react';
import i18next from 'i18next';
import EADialog from '../../common/EADialog';
import useStyles
  from "../../../style/js-style/containers/thirdparties/unmanagedThirdParty/CreateUnmanagedThirdPartyStyle";
import _ from 'lodash';
import { useForm } from 'react-hook-form';
import AttributesStep from '../AttributesStep';
import EAColorIcon from '../../common/EAColorIcon';
import InfoBloc from 'components/common/InfoBloc';
import { WARNING } from 'services/common/Constants';

function ManagedThirdParty({ isOpen, onClose, setAttributes, handleValidate, accountAttributes, bondType,
                             hasRestrictedDisclosure }) {
  const { classes } = useStyles();

  const getFormDefaultValues = () => {
    return {
        attributes: []
      }
  };

  const formMethods = useForm({
    mode: "onChange",
    delayError: 500,
    defaultValues: getFormDefaultValues(),
  });

  const {
    formState: { errors },
    setValue
  } = formMethods;

  const watchAttributes = formMethods.watch("attributes");

  // Met à jour les valeurs d'attributs
  useEffect(() => {
    setAttributes(watchAttributes);
    // eslint-disable-next-line
  }, [watchAttributes]);

  useEffect(() => {
    setValue("attributes", accountAttributes)
    // eslint-disable-next-line
  }, [accountAttributes]);

  const onValidate = () => {
    if (_.isEmpty(errors)){
      handleValidate();
    }
  }

  return accountAttributes && accountAttributes.length > 0  && (
    <EADialog
      isOpen={isOpen}
      title={
        <div style={{ className: classes.popUpTitle }}>
          <EAColorIcon
            icon={'unmanagedThirdParty/unmanagedThirdParty'}
            className={classes.popUpTitleIcon}
            svgStyle={{marginRight: "5px", position: "relative", top: "3px"}}
          />
          {i18next.t('thirdpartySearch.createNewThirdPartyManaged')}
        </div>
      }
      onCancel={onClose}
      onClose={onClose}
      maxWidth="popupmd"
      fullWidth
      validateBtnLabel={i18next.t('validate')}
      onValidate={onValidate}
      customBtnStyle={{
        justifyContent: 'flex-end !important',
        marginRight: '16px',
        marginTop: '5px',
      }}
      isValidateDisabled={!_.isEmpty(errors)}
    >
      {hasRestrictedDisclosure && (
        <InfoBloc severity={WARNING} title={i18next.t("hasRestrictedDisclosure.tpTitle")} text={i18next.t("hasRestrictedDisclosure.tooltip")} />
      )}
      <AttributesStep formMethods={formMethods} bondType={bondType}/>
    </EADialog>
  );
}

export default ManagedThirdParty;
